import { render, staticRenderFns } from "./PrazosDeVencimento.vue?vue&type=template&id=35363650"
import script from "./PrazosDeVencimento.vue?vue&type=script&lang=ts"
export * from "./PrazosDeVencimento.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports